export default "__VITE_PUBLIC_ASSET__7dd854bc__"